export * from './actuators.service';
import { ActuatorsService } from './actuators.service';
export * from './actuatorsDeprecated.service';
import { ActuatorsDeprecatedService } from './actuatorsDeprecated.service';
export * from './assessmentReports.service';
import { AssessmentReportsService } from './assessmentReports.service';
export * from './assessmentReportsDeprecated.service';
import { AssessmentReportsDeprecatedService } from './assessmentReportsDeprecated.service';
export * from './documents.service';
import { DocumentsService } from './documents.service';
export * from './documentsDeprecated.service';
import { DocumentsDeprecatedService } from './documentsDeprecated.service';
export const APIS = [ActuatorsService, ActuatorsDeprecatedService, AssessmentReportsService, AssessmentReportsDeprecatedService, DocumentsService, DocumentsDeprecatedService];
